module.exports = __webpack_public_path__ + "static/media/sheding2.d73a4fe8.png";